import React from 'react';
import { PriceTriggerSubType } from '../../../../../../data-access/gql-types/graphql';
import { useTriggerFormContext } from '../../context/provider';
import { StepComponentProps } from '../../steps';
import PriceConditionForm from './components/price-condition-form';
import TariffSelect from './components/tariff-select';
import './index.scss';

export const PriceCondition: React.FC<StepComponentProps> = ({ goToChannels, goToSummary }) => {
  const { priceConditionConfig } = useTriggerFormContext();

  return (
    <div className="condition-section--container">
      <TariffSelect />
      {priceConditionConfig.subType !== PriceTriggerSubType.Unknown && (
        <PriceConditionForm goToChannels={goToChannels} goToSummary={goToSummary} />
      )}
    </div>
  );
};
